/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    return value.toString().padStart(2, '0')
  })
  return timeStr
}

/**
 * 格式化日期时间
 * @param {(Object|string|number)} time
 * @returns {string}
 */
export function formatDateTime(time) {
  if (!time) {
    return '';
  }

  // 处理特殊情况，防止NaN
  try {
    // 检查是否为无效日期
    const testDate = new Date(time);
    if (isNaN(testDate.getTime())) {
      // 尝试其他日期格式转换
      if (typeof time === 'string') {
        // 尝试转换YYYY-MM-DDThh:mm:ss格式
        if (time.includes('T')) {
          return parseTime(time.replace('T', ' '), '{y}-{m}-{d} {h}:{i}:{s}');
        }

        // 尝试ISO日期格式
        const isoDate = new Date(time);
        if (!isNaN(isoDate.getTime())) {
          return parseTime(isoDate, '{y}-{m}-{d} {h}:{i}:{s}');
        }
      }
      return time; // 返回原始值，以避免显示NaN
    }
  } catch (error) {
    console.error('日期格式化错误', error);
    return time; // 出错时返回原始值
  }

  return parseTime(time, '{y}-{m}-{d} {h}:{i}:{s}');
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

/**
 * 处理Java LocalDateTime序列化后的格式
 * 例如: [2023,5,12,15,30,45] -> 2023-05-12 15:30:45
 * 或者: {"year":2023,"month":5,"day":12,"hour":15,"minute":30,"second":45}
 * @param {string|array|object} dateValue
 * @returns {string}
 */
export function formatJavaLocalDateTime(dateValue) {
  if (!dateValue) return '';

  try {
    // 如果是数组格式 [year,month,day,hour,minute,second]
    if (Array.isArray(dateValue)) {
      const [year, month, day, hour = 0, minute = 0, second = 0] = dateValue;
      return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')} ${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:${String(second).padStart(2, '0')}`;
    }

    // 如果是字符串形式的数组 "[2023,5,12,15,30,45]"
    if (typeof dateValue === 'string' && dateValue.startsWith('[') && dateValue.endsWith(']')) {
      try {
        const dateArray = JSON.parse(dateValue);
        return formatJavaLocalDateTime(dateArray);
      } catch (e) {
        console.error('解析日期数组字符串失败:', e);
      }
    }

    // 如果是对象格式 {"year":2023,"month":5,"day":12,...}
    if (typeof dateValue === 'object' && dateValue !== null) {
      const { year, month, day, hour = 0, minute = 0, second = 0 } = dateValue;
      if (year && month && day) {
        return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')} ${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:${String(second).padStart(2, '0')}`;
      }
    }

    // 如果是标准ISO日期格式
    const date = new Date(dateValue);
    if (!isNaN(date.getTime())) {
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
    }
  } catch (error) {
    console.error('格式化Java日期失败:', error, dateValue);
  }

  // 如果所有尝试都失败，返回原始值
  return String(dateValue);
}
